import { gql } from '@apollo/client'

export const SEND_GROUP_EVENT_REGISTRATION_INVITE = gql`
  mutation SendGroupEventRegistrationInvite(
    $groupEventId: ID!
    $contactId: ID!
  ) {
    sendGroupEventRegistrationInvite(
      groupEventId: $groupEventId
      contactId: $contactId
    ) {
      success
      message
    }
  }
`

export const REVOKE_GROUP_EVENT_REGISTRATION_INVITE = gql`
  mutation RevokeGroupEventRegistrationInvite(
    $groupEventId: ID!
    $contactId: ID!
  ) {
    revokeGroupEventRegistrationInvite(
      groupEventId: $groupEventId
      contactId: $contactId
    ) {
      success
      message
    }
  }
`
